import React from 'react';
import CardEmpty from "Utils/Cards/CardEmpty";
import { Field } from 'redux-form';
import { ModalDRC } from "./ModalDRC";
import { TablaDRC } from './TablaDRC';
import { renderNumberPercentage } from '../../../../Utils/renderField/renderField';
import { RenderNumber } from '../../../../Utils/renderField/renderReadField';
import './DatosDRC.css';

// Puede servir para testing y verificar los cálculos
const mostrarVariacionDRC = false;

/**
 * Componente para renderizar los datos de DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioSolidoForm)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {*} props propiedades del componente
 * @returns {JSX.Element} componente de datos de DRC
 */
export const renderDatosDRC = (props) => {
    return (
        <div className="col-12 responsive-table-fix datos-drc-solidos-edicion__container">
            <ModalDRC {...props} mostrarVariacionDRC={mostrarVariacionDRC} />
            <TablaDRC {...props} mostrarVariacionDRC={mostrarVariacionDRC} />
        </div>
    )
};

/**
 * Componente para renderizar los promedios de DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioSolidoForm)
 * @param {*} props propiedades del componente
 * @returns {JSX.Element} componente de promedios de DRC
 */
export const PromediosDRC = (props) => {
    const { drc_promedio, drc_minimo, drc_maximo, drc_diferencia } = props;

    return (
        <CardEmpty noShadow>
            <div className="row col-12 m-0 py-3 mb-3">
                <div className="row col-12 mb-3">
                    <div className="col-1"></div>
                    <div className="col-11">
                        <h6 className="">RESULTADO DE DRC</h6>
                    </div>

                </div>
                <div className="row col-12">
                    <div className="col-3">
                        <span className="verde-secundario bold ml-2">PROMEDIO</span>
                        <Field name="drc_promedio" component={renderNumberPercentage} disabled type="text" className="form-control"
                            input={{ value: (isNaN(drc_promedio) || !isFinite(drc_promedio)) ? 0 : drc_promedio }} />
                    </div>
                    <div className="col-3">
                        <span className="verde-secundario bold ml-2">MÍNIMO</span>
                        <Field name="drc_minimo" component={renderNumberPercentage} disabled type="text" className="form-control"
                            input={{ value: (isNaN(drc_minimo) || !isFinite(drc_minimo)) ? 0 : drc_minimo }} />
                    </div>
                    <div className="col-3">
                        <span className="verde-secundario bold ml-2">MÁXIMO</span>
                        <Field name="drc_maximo" component={renderNumberPercentage} disabled type="text" className="form-control"
                            input={{ value: (isNaN(drc_maximo) || !isFinite(drc_maximo)) ? 0 : drc_maximo }} />
                    </div>
                    <div className="col-3">
                        <span className="verde-secundario bold ml-2">DIFERENCIA</span>
                        <Field name="drc_diferencia" component={renderNumberPercentage} disabled type="text" className="form-control"
                            input={{ value: (isNaN(drc_diferencia) || !isFinite(drc_diferencia)) ? 0 : drc_diferencia }} />
                    </div>
                </div>
            </div>
        </CardEmpty>
    )
}

/**
 * Componente para renderizar el header de los datos DRC
 * Se creó para refactorizar el contenido en el componente general (LaboratorioSolidoForm)
 * Solo se hicieron cambios respectivos a la variación DRC
 * @param {*} props propiedades del componente
 * @returns {JSX.Element} componente de header de datos DRC
 */
export const HeaderDRC = (props) => {
    const { openModal, clearDRCTemp, variacionDRC } = props;

    return (
        <div className="datos-drc-solidos-edicion__top">
            <button className="btn btn-outline-info"
                onClick={e => {
                    e.preventDefault();
                    clearDRCTemp();
                    openModal('drc')
                }}>
                AGREGAR DRC
            </button>
            {mostrarVariacionDRC &&
                <div className="d-flex align-items-center">
                    <span className="verde-secundario bold mr-2">VARIACIÓN DRC</span>
                    {variacionDRC.aplica ?
                        <RenderNumber value={variacionDRC.variacion} decimalScale={2}
                            className="datos-drc-solidos-edicion__dato-variacion" suffix=" %" />
                        :
                        <span className="datos-drc-solidos-edicion__dato-variacion">No aplica</span>
                    }
                </div>
            }
        </div>
    )
}

